const translations = {
  pt: {
    // Sidebar
    painelLojista: "Painel Lojista",
    menu: "Menu",
    dashboard: "Dashboard",
    pedidos: "Pedidos",
    relatorios: "Relatórios",
    cadastro: "Cadastro",
    configuracao: "Configuração",

    // Sidebar - Relatórios
    vendidos: "Vendidos",
    cancelados: "Cancelados",
    dia: "Dia",
    mes: "Mês",
    ano: "Ano",
    financeiro: "Financeiro",
    pagamentos: "Pagamentos",
    dinheiro: "Dinheiro",
    cartao: "Cartão",
    pix: "PIX",
    cashback: "Cashback",
    entregadores: "Entregadores",
    geral: "Geral",
    porEntregador: "Por Entregador",
    pagos: "Pagos",
    aReceber: "A Receber",
    saldo: "Saldo",

    // Sidebar - Cadastro
    categorias: "Categorias",
    subCategorias: "Sub Categorias",
    produtos: "Produtos",
    adicionais: "Adicionais",
    caixinhaSurpresa: "Caixinha Surpresa",

    // Sidebar - Configuração
    horarios: "Horários",
    dadosConta: "Dados da Conta",
    apiPagamento: "API Pagamento",
    impressora: "Impressora",
    tiposPagamento: "Tipos de Pagamento",
    idiomas: "Idiomas",

    // Dashboard
    bemVindo: "Bem-vindo de volta",
    faturamento: "Faturamento",
    totalPedidos: "Total Pedidos",
    ticketMedio: "Ticket Médio",
    ativos: "Ativos",
    pedidosPorHora: "Pedidos por Hora",
    ultimosPedidos: "Últimos Pedidos",
    verTodos: "Ver todos →",
    nenhumPedido: "Nenhum pedido",
    codigo: "Código",
    status: "Status",
    pagamento: "Pagamento",
    total: "Total",
    data: "Data",

    // Pedidos
    atualizar: "Atualizar",
    todos: "Todos",
    novos: "Novos",
    aceitos: "Aceitos",
    preparando: "Preparando",
    prontos: "Prontos",
    entrega: "Entrega",
    entregues: "Entregues",
    selecionePedido: "Selecione um pedido",
    informacoes: "Informações",
    itens: "Itens",
    subtotal: "Subtotal",
    taxaEntrega: "Taxa entrega",
    desconto: "Desconto",
    recusarPedido: "Recusar Pedido",
    aceitar: "Aceitar",
    ficouPronto: "Ficou Pronto",
    saiuEntrega: "Saiu p/ Entrega",
    entregue: "Entregue",

    // Status labels
    stNovo: "Novo",
    stAceito: "Aceito",
    stPreparando: "Preparando",
    stPronto: "Pronto",
    stBuscando: "Buscando Entregador",
    stEmEntrega: "Em Entrega",
    stEntregue: "Entregue",
    stCancelado: "Cancelado",

    // Relatórios
    faturamentoTotal: "Faturamento Total",
    formasUtilizadas: "Formas Utilizadas",
    porValor: "Por Valor",
    detalhamento: "Detalhamento",
    forma: "Forma",
    pedidosHoje: "Pedidos Hoje",
    pedidosMes: "Pedidos Mês",
    pedidosAno: "Pedidos Ano",
    porHora: "Por Hora",
    pedidosPorDia: "Pedidos por Dia",
    pedidosPorMes: "Pedidos por Mês",
    perdaEstimada: "Perda Estimada",
    nenhum: "Nenhum",
    nenhumCancelado: "Nenhum cancelado",
    nenhumPedidoVendido: "Nenhum pedido vendido",
    nenhumPedidoHoje: "Nenhum pedido hoje",
    semDados: "Sem dados",
    totalEntregas: "Total Entregas",
    entregadoresAtivos: "Entregadores Ativos",
    faturamentoEntregas: "Faturamento Entregas",
    resumoGeral: "Resumo Geral",
    ranking: "Ranking",
    entregas: "Entregas",
    media: "Média",
    entregasHoje: "Entregas Hoje",
    entregasMes: "Entregas Mês",
    entregasAno: "Entregas Ano",
    totalPago: "Total Pago",
    entregasPagas: "Entregas Pagas",
    moduloEmDev: "Módulo de pagamento de entregadores em desenvolvimento",
    totalAReceber: "Total a Receber",
    valorAReceber: "Valor a Receber",
    nenhumValorPendente: "Nenhum valor pendente",
    totalAPagar: "Total a Pagar",
    balancoGeral: "Balanço geral de pagamentos a entregadores",
    doTotal: "% do Total",
    nenhumaEntrega: "Nenhuma entrega",
    nenhumaEntregaHoje: "Nenhuma entrega hoje",
    nenhumaEntregaMes: "Nenhuma entrega no mês",
    nenhumaEntregaAno: "Nenhuma entrega no ano",
    entregasRealizadasHoje: "entregas realizadas hoje",
    entregasNoMes: "entregas no mês",
    entregasNoAno: "entregas no ano",

    // Cadastro
    novoCadastro: "Novo Cadastro",
    cadastrados: "Cadastrados",
    nomeDaCategoria: "Nome da Categoria",
    descricao: "Descrição",
    ordem: "Ordem",
    cadastrarCategoria: "Cadastrar Categoria",
    categoria: "Categoria",
    nome: "Nome",
    cadastrarSubCategoria: "Cadastrar Sub Categoria",
    nomeDoProduto: "Nome do Produto",
    preco: "Preço (R$)",
    subCategoria: "Sub Categoria",
    disponivel: "Disponível",
    sim: "Sim",
    nao: "Não",
    cadastrarProduto: "Cadastrar Produto",
    obrigatorio: "Obrigatório",
    maxEscolhas: "Máx Escolhas",
    cadastrarAdicional: "Cadastrar Adicional",
    precoPromocional: "Preço Promocional (R$)",
    precoOriginal: "Preço Original (R$)",
    limiteUnidades: "Limite de Unidades",
    ativo: "Ativo",
    inativo: "Inativo",
    cadastrarCaixinha: "Cadastrar Caixinha",
    selecione: "Selecione",
    nenhuma: "Nenhuma",
    todas: "Todas",
    opcional: "Opcional",
    cadastrado: "cadastrado(a)",
    erroCadastrar: "Erro ao cadastrar",
    erroConexao: "Erro de conexão",

    // Configuração
    horariosFuncionamento: "Horários de Funcionamento",
    segunda: "Segunda", terca: "Terça", quarta: "Quarta", quinta: "Quinta",
    sexta: "Sexta", sabado: "Sábado", domingo: "Domingo",
    aberto: "Aberto",
    fechado: "Fechado",
    salvarHorarios: "Salvar Horários",
    adicionarTurno: "Adicionar turno",
    removerTurno: "Remover turno",
    horariosTurnoDica: "Adicione vários turnos no mesmo dia (ex: café da manhã, almoço, jantar).",
    forcadoOnline: "Forçado",
    forcadoOnlineTooltip: "Forçado online — volta pro horário automático em",
    forcadoOfflineTooltip: "Forçado offline — volta pro horário automático em",
    pausarBtn: "Pausar",
    pausarPor: "PAUSAR POR",
    pausar30min: "30 minutos",
    pausar1h: "1 hora",
    pausar2h: "2 horas",
    pausarConfirm: "Pausar a loja por {tempo}? A loja vai aparecer fechada pros clientes durante esse tempo.",
    cancelarPausaConfirm: "Cancelar a pausa e voltar ao modo automático?",
    cancelarPausa: "✕ Cancelar pausa",
    cancelarPausaBtn: "Cancelar pausa",
    pausada: "Pausada",
    lojaPausada: "Loja pausada",
    voltaAutomaticoEm: "Volta automaticamente em",
    pausaCanceladaMsg: "Pausa cancelada — modo automático ativo",
    erroPausarLoja: "Erro ao pausar loja",
    erroCancelarPausa: "Erro ao cancelar pausa",
    lojaPausadaPor: "Loja pausada por",
    lojaOnlineMsg: "Loja ONLINE ✓",
    lojaOfflineMsg: "Loja OFFLINE",
    forcadoOnlineLabel: "Forçado Online",
    forcadoOfflineLabel: "Forçado Offline",
    voltaHorarioAs: "Volta pro horário automático às",
    voltaHorarioProximo: "Volta pro horário automático no próximo evento de horário",
    voltarAutomatico: "Voltar pro automático",
    informacoesLoja: "Informações da Loja",
    nomeLoja: "Nome da Loja",
    telefone: "Telefone",
    email: "Email",
    endereco: "Endereço",
    cidade: "Cidade",
    estado: "Estado",
    salvarDados: "Salvar Dados",
    salvando: "Salvando...",
    dadosAtualizados: "Dados atualizados!",
    erroSalvar: "Erro ao salvar",
    idLoja: "ID da Loja",
    taxasAdmin: "Taxas de entrega e tempos são configurados pelo administrador no Painel Admin.",
    integracaoMP: "Integração Mercado Pago",
    configCredenciais: "Configure as credenciais para receber pagamentos online",
    accessToken: "Access Token",
    publicKey: "Public Key",
    webhookUrl: "Webhook URL",
    credenciaisInfo: "As credenciais são encontradas no painel do Mercado Pago em Configurações → Credenciais",
    salvarConfiguracao: "Salvar Configuração",
    apiConfigurada: "API configurada!",
    configImpressora: "Configuração de Impressora",
    tipoConexao: "Tipo de Conexão",
    bluetooth: "Bluetooth",
    usb: "USB",
    wifiRede: "Wi-Fi / Rede",
    nomeDispositivo: "Nome/IP do Dispositivo",
    larguraPapel: "Largura do Papel",
    imprimirAuto: "Imprimir Automaticamente",
    simImprimir: "Sim - Imprimir ao receber pedido",
    naoImprimir: "Não - Imprimir manualmente",
    salvarImpressora: "Salvar Impressora",
    impressoraConfigurada: "Impressora configurada!",
    tiposPagAceitos: "Tipos de Pagamento Aceitos",
    ativeDesative: "Ative ou desative as formas de pagamento da sua loja",
    cartaoCredito: "Cartão Crédito",
    cartaoDebito: "Cartão Débito",
    valeRefeicao: "Vale Refeição",
    pagamentosAtualizados: "Pagamentos atualizados!",
    salvarPagamentos: "Salvar Pagamentos",
    horariosAlvo: "Horários salvos!",

    // Idiomas
    idiomasTitulo: "Idioma do Painel",
    idiomasDesc: "Escolha o idioma de exibição de todo o painel",
    idiomaAtual: "Idioma atual",
    portugues: "Português",
    ingles: "English",
    espanhol: "Español",
    guarani: "Guarani",
    idiomaSalvo: "Idioma alterado!",
  },

  en: {
    painelLojista: "Store Panel",
    menu: "Menu",
    dashboard: "Dashboard",
    pedidos: "Orders",
    relatorios: "Reports",
    cadastro: "Register",
    configuracao: "Settings",

    vendidos: "Sold",
    cancelados: "Cancelled",
    dia: "Day",
    mes: "Month",
    ano: "Year",
    financeiro: "Financial",
    pagamentos: "Payments",
    dinheiro: "Cash",
    cartao: "Card",
    pix: "PIX",
    cashback: "Cashback",
    entregadores: "Drivers",
    geral: "General",
    porEntregador: "By Driver",
    pagos: "Paid",
    aReceber: "Receivable",
    saldo: "Balance",

    categorias: "Categories",
    subCategorias: "Subcategories",
    produtos: "Products",
    adicionais: "Add-ons",
    caixinhaSurpresa: "Mystery Box",

    horarios: "Hours",
    dadosConta: "Account",
    apiPagamento: "Payment API",
    impressora: "Printer",
    tiposPagamento: "Payment Types",
    idiomas: "Languages",

    bemVindo: "Welcome back",
    faturamento: "Revenue",
    totalPedidos: "Total Orders",
    ticketMedio: "Avg Ticket",
    ativos: "Active",
    pedidosPorHora: "Orders by Hour",
    ultimosPedidos: "Recent Orders",
    verTodos: "View all →",
    nenhumPedido: "No orders",
    codigo: "Code",
    status: "Status",
    pagamento: "Payment",
    total: "Total",
    data: "Date",

    atualizar: "Refresh",
    todos: "All",
    novos: "New",
    aceitos: "Accepted",
    preparando: "Preparing",
    prontos: "Ready",
    entrega: "Delivery",
    entregues: "Delivered",
    selecionePedido: "Select an order",
    informacoes: "Information",
    itens: "Items",
    subtotal: "Subtotal",
    taxaEntrega: "Delivery fee",
    desconto: "Discount",
    recusarPedido: "Reject Order",
    aceitar: "Accept",
    ficouPronto: "Ready",
    saiuEntrega: "Out for Delivery",
    entregue: "Delivered",

    stNovo: "New",
    stAceito: "Accepted",
    stPreparando: "Preparing",
    stPronto: "Ready",
    stBuscando: "Finding Driver",
    stEmEntrega: "Out for Delivery",
    stEntregue: "Delivered",
    stCancelado: "Cancelled",

    faturamentoTotal: "Total Revenue",
    formasUtilizadas: "Payment Methods",
    porValor: "By Value",
    detalhamento: "Details",
    forma: "Method",
    pedidosHoje: "Orders Today",
    pedidosMes: "Orders This Month",
    pedidosAno: "Orders This Year",
    porHora: "By Hour",
    pedidosPorDia: "Orders by Day",
    pedidosPorMes: "Orders by Month",
    perdaEstimada: "Estimated Loss",
    nenhum: "None",
    nenhumCancelado: "No cancellations",
    nenhumPedidoVendido: "No sold orders",
    nenhumPedidoHoje: "No orders today",
    semDados: "No data",
    totalEntregas: "Total Deliveries",
    entregadoresAtivos: "Active Drivers",
    faturamentoEntregas: "Delivery Revenue",
    resumoGeral: "Overview",
    ranking: "Ranking",
    entregas: "Deliveries",
    media: "Average",
    entregasHoje: "Deliveries Today",
    entregasMes: "Deliveries Month",
    entregasAno: "Deliveries Year",
    totalPago: "Total Paid",
    entregasPagas: "Paid Deliveries",
    moduloEmDev: "Driver payment module in development",
    totalAReceber: "Total Receivable",
    valorAReceber: "Amount Receivable",
    nenhumValorPendente: "No pending amounts",
    totalAPagar: "Total Payable",
    balancoGeral: "General balance of driver payments",
    doTotal: "% of Total",
    nenhumaEntrega: "No deliveries",
    nenhumaEntregaHoje: "No deliveries today",
    nenhumaEntregaMes: "No deliveries this month",
    nenhumaEntregaAno: "No deliveries this year",
    entregasRealizadasHoje: "deliveries made today",
    entregasNoMes: "deliveries this month",
    entregasNoAno: "deliveries this year",

    novoCadastro: "New Entry",
    cadastrados: "Registered",
    nomeDaCategoria: "Category Name",
    descricao: "Description",
    ordem: "Order",
    cadastrarCategoria: "Register Category",
    categoria: "Category",
    nome: "Name",
    cadastrarSubCategoria: "Register Subcategory",
    nomeDoProduto: "Product Name",
    preco: "Price (R$)",
    subCategoria: "Subcategory",
    disponivel: "Available",
    sim: "Yes",
    nao: "No",
    cadastrarProduto: "Register Product",
    obrigatorio: "Required",
    maxEscolhas: "Max Choices",
    cadastrarAdicional: "Register Add-on",
    precoPromocional: "Promo Price (R$)",
    precoOriginal: "Original Price (R$)",
    limiteUnidades: "Unit Limit",
    ativo: "Active",
    inativo: "Inactive",
    cadastrarCaixinha: "Register Mystery Box",
    selecione: "Select",
    nenhuma: "None",
    todas: "All",
    opcional: "Optional",
    cadastrado: "registered",
    erroCadastrar: "Error registering",
    erroConexao: "Connection error",

    horariosFuncionamento: "Business Hours",
    segunda: "Monday", terca: "Tuesday", quarta: "Wednesday", quinta: "Thursday",
    sexta: "Friday", sabado: "Saturday", domingo: "Sunday",
    aberto: "Open",
    fechado: "Closed",
    salvarHorarios: "Save Hours",
    adicionarTurno: "Add shift",
    removerTurno: "Remove shift",
    horariosTurnoDica: "Add multiple shifts in the same day (e.g. breakfast, lunch, dinner).",
    forcadoOnline: "Forced",
    forcadoOnlineTooltip: "Forced online — returns to automatic schedule in",
    forcadoOfflineTooltip: "Forced offline — returns to automatic schedule in",
    pausarBtn: "Pause",
    pausarPor: "PAUSE FOR",
    pausar30min: "30 minutes",
    pausar1h: "1 hour",
    pausar2h: "2 hours",
    pausarConfirm: "Pause the store for {tempo}? The store will appear closed to customers during this time.",
    cancelarPausaConfirm: "Cancel the pause and return to automatic mode?",
    cancelarPausa: "✕ Cancel pause",
    cancelarPausaBtn: "Cancel pause",
    pausada: "Paused",
    lojaPausada: "Store paused",
    voltaAutomaticoEm: "Returns automatically in",
    pausaCanceladaMsg: "Pause cancelled — automatic mode active",
    erroPausarLoja: "Error pausing store",
    erroCancelarPausa: "Error cancelling pause",
    lojaPausadaPor: "Store paused for",
    lojaOnlineMsg: "Store ONLINE ✓",
    lojaOfflineMsg: "Store OFFLINE",
    forcadoOnlineLabel: "Forced Online",
    forcadoOfflineLabel: "Forced Offline",
    voltaHorarioAs: "Returns to automatic schedule at",
    voltaHorarioProximo: "Returns to automatic schedule on next schedule event",
    voltarAutomatico: "Return to automatic",
    informacoesLoja: "Store Information",
    nomeLoja: "Store Name",
    telefone: "Phone",
    email: "Email",
    endereco: "Address",
    cidade: "City",
    estado: "State",
    salvarDados: "Save Data",
    salvando: "Saving...",
    dadosAtualizados: "Data updated!",
    erroSalvar: "Error saving",
    idLoja: "Store ID",
    taxasAdmin: "Delivery fees and times are set by the administrator in the Admin Panel.",
    integracaoMP: "Mercado Pago Integration",
    configCredenciais: "Set up credentials to receive online payments",
    accessToken: "Access Token",
    publicKey: "Public Key",
    webhookUrl: "Webhook URL",
    credenciaisInfo: "Credentials can be found in the Mercado Pago dashboard under Settings → Credentials",
    salvarConfiguracao: "Save Settings",
    apiConfigurada: "API configured!",
    configImpressora: "Printer Setup",
    tipoConexao: "Connection Type",
    bluetooth: "Bluetooth",
    usb: "USB",
    wifiRede: "Wi-Fi / Network",
    nomeDispositivo: "Device Name/IP",
    larguraPapel: "Paper Width",
    imprimirAuto: "Auto Print",
    simImprimir: "Yes - Print on order received",
    naoImprimir: "No - Print manually",
    salvarImpressora: "Save Printer",
    impressoraConfigurada: "Printer configured!",
    tiposPagAceitos: "Accepted Payment Types",
    ativeDesative: "Enable or disable your store's payment methods",
    cartaoCredito: "Credit Card",
    cartaoDebito: "Debit Card",
    valeRefeicao: "Meal Voucher",
    pagamentosAtualizados: "Payments updated!",
    salvarPagamentos: "Save Payments",
    horariosAlvo: "Hours saved!",

    idiomasTitulo: "Panel Language",
    idiomasDesc: "Choose the display language for the entire panel",
    idiomaAtual: "Current language",
    portugues: "Português",
    ingles: "English",
    espanhol: "Español",
    guarani: "Guarani",
    idiomaSalvo: "Language changed!",
  },

  es: {
    painelLojista: "Panel Tienda",
    menu: "Menú",
    dashboard: "Dashboard",
    pedidos: "Pedidos",
    relatorios: "Informes",
    cadastro: "Registro",
    configuracao: "Configuración",

    vendidos: "Vendidos",
    cancelados: "Cancelados",
    dia: "Día",
    mes: "Mes",
    ano: "Año",
    financeiro: "Financiero",
    pagamentos: "Pagos",
    dinheiro: "Efectivo",
    cartao: "Tarjeta",
    pix: "PIX",
    cashback: "Cashback",
    entregadores: "Repartidores",
    geral: "General",
    porEntregador: "Por Repartidor",
    pagos: "Pagados",
    aReceber: "Por Cobrar",
    saldo: "Saldo",

    categorias: "Categorías",
    subCategorias: "Subcategorías",
    produtos: "Productos",
    adicionais: "Adicionales",
    caixinhaSurpresa: "Caja Sorpresa",

    horarios: "Horarios",
    dadosConta: "Datos de Cuenta",
    apiPagamento: "API de Pago",
    impressora: "Impresora",
    tiposPagamento: "Tipos de Pago",
    idiomas: "Idiomas",

    bemVindo: "Bienvenido",
    faturamento: "Facturación",
    totalPedidos: "Total Pedidos",
    ticketMedio: "Ticket Promedio",
    ativos: "Activos",
    pedidosPorHora: "Pedidos por Hora",
    ultimosPedidos: "Últimos Pedidos",
    verTodos: "Ver todos →",
    nenhumPedido: "Sin pedidos",
    codigo: "Código",
    status: "Estado",
    pagamento: "Pago",
    total: "Total",
    data: "Fecha",

    atualizar: "Actualizar",
    todos: "Todos",
    novos: "Nuevos",
    aceitos: "Aceptados",
    preparando: "Preparando",
    prontos: "Listos",
    entrega: "Entrega",
    entregues: "Entregados",
    selecionePedido: "Seleccione un pedido",
    informacoes: "Información",
    itens: "Ítems",
    subtotal: "Subtotal",
    taxaEntrega: "Costo envío",
    desconto: "Descuento",
    recusarPedido: "Rechazar Pedido",
    aceitar: "Aceptar",
    ficouPronto: "Listo",
    saiuEntrega: "En Camino",
    entregue: "Entregado",

    stNovo: "Nuevo",
    stAceito: "Aceptado",
    stPreparando: "Preparando",
    stPronto: "Listo",
    stBuscando: "Buscando Repartidor",
    stEmEntrega: "En Camino",
    stEntregue: "Entregado",
    stCancelado: "Cancelado",

    faturamentoTotal: "Facturación Total",
    formasUtilizadas: "Métodos de Pago",
    porValor: "Por Valor",
    detalhamento: "Detalle",
    forma: "Método",
    pedidosHoje: "Pedidos Hoy",
    pedidosMes: "Pedidos del Mes",
    pedidosAno: "Pedidos del Año",
    porHora: "Por Hora",
    pedidosPorDia: "Pedidos por Día",
    pedidosPorMes: "Pedidos por Mes",
    perdaEstimada: "Pérdida Estimada",
    nenhum: "Ninguno",
    nenhumCancelado: "Sin cancelaciones",
    nenhumPedidoVendido: "Sin pedidos vendidos",
    nenhumPedidoHoje: "Sin pedidos hoy",
    semDados: "Sin datos",
    totalEntregas: "Total Entregas",
    entregadoresAtivos: "Repartidores Activos",
    faturamentoEntregas: "Facturación Entregas",
    resumoGeral: "Resumen General",
    ranking: "Ranking",
    entregas: "Entregas",
    media: "Promedio",
    entregasHoje: "Entregas Hoy",
    entregasMes: "Entregas Mes",
    entregasAno: "Entregas Año",
    totalPago: "Total Pagado",
    entregasPagas: "Entregas Pagadas",
    moduloEmDev: "Módulo de pago a repartidores en desarrollo",
    totalAReceber: "Total por Cobrar",
    valorAReceber: "Monto por Cobrar",
    nenhumValorPendente: "Sin montos pendientes",
    totalAPagar: "Total a Pagar",
    balancoGeral: "Balance general de pagos a repartidores",
    doTotal: "% del Total",
    nenhumaEntrega: "Sin entregas",
    nenhumaEntregaHoje: "Sin entregas hoy",
    nenhumaEntregaMes: "Sin entregas este mes",
    nenhumaEntregaAno: "Sin entregas este año",
    entregasRealizadasHoje: "entregas realizadas hoy",
    entregasNoMes: "entregas en el mes",
    entregasNoAno: "entregas en el año",

    novoCadastro: "Nuevo Registro",
    cadastrados: "Registrados",
    nomeDaCategoria: "Nombre de Categoría",
    descricao: "Descripción",
    ordem: "Orden",
    cadastrarCategoria: "Registrar Categoría",
    categoria: "Categoría",
    nome: "Nombre",
    cadastrarSubCategoria: "Registrar Subcategoría",
    nomeDoProduto: "Nombre del Producto",
    preco: "Precio (R$)",
    subCategoria: "Subcategoría",
    disponivel: "Disponible",
    sim: "Sí",
    nao: "No",
    cadastrarProduto: "Registrar Producto",
    obrigatorio: "Obligatorio",
    maxEscolhas: "Máx Opciones",
    cadastrarAdicional: "Registrar Adicional",
    precoPromocional: "Precio Promocional (R$)",
    precoOriginal: "Precio Original (R$)",
    limiteUnidades: "Límite de Unidades",
    ativo: "Activo",
    inativo: "Inactivo",
    cadastrarCaixinha: "Registrar Caja Sorpresa",
    selecione: "Seleccione",
    nenhuma: "Ninguna",
    todas: "Todas",
    opcional: "Opcional",
    cadastrado: "registrado(a)",
    erroCadastrar: "Error al registrar",
    erroConexao: "Error de conexión",

    horariosFuncionamento: "Horarios de Atención",
    segunda: "Lunes", terca: "Martes", quarta: "Miércoles", quinta: "Jueves",
    sexta: "Viernes", sabado: "Sábado", domingo: "Domingo",
    aberto: "Abierto",
    fechado: "Cerrado",
    salvarHorarios: "Guardar Horarios",
    adicionarTurno: "Agregar turno",
    removerTurno: "Quitar turno",
    horariosTurnoDica: "Agregue varios turnos en el mismo día (ej: desayuno, almuerzo, cena).",
    forcadoOnline: "Forzado",
    forcadoOnlineTooltip: "Forzado online — vuelve al horario automático en",
    forcadoOfflineTooltip: "Forzado offline — vuelve al horario automático en",
    pausarBtn: "Pausar",
    pausarPor: "PAUSAR POR",
    pausar30min: "30 minutos",
    pausar1h: "1 hora",
    pausar2h: "2 horas",
    pausarConfirm: "¿Pausar la tienda por {tempo}? La tienda aparecerá cerrada para los clientes durante ese tiempo.",
    cancelarPausaConfirm: "¿Cancelar la pausa y volver al modo automático?",
    cancelarPausa: "✕ Cancelar pausa",
    cancelarPausaBtn: "Cancelar pausa",
    pausada: "Pausada",
    lojaPausada: "Tienda pausada",
    voltaAutomaticoEm: "Vuelve automáticamente en",
    pausaCanceladaMsg: "Pausa cancelada — modo automático activo",
    erroPausarLoja: "Error al pausar tienda",
    erroCancelarPausa: "Error al cancelar pausa",
    lojaPausadaPor: "Tienda pausada por",
    lojaOnlineMsg: "Tienda ONLINE ✓",
    lojaOfflineMsg: "Tienda OFFLINE",
    forcadoOnlineLabel: "Forzado Online",
    forcadoOfflineLabel: "Forzado Offline",
    voltaHorarioAs: "Vuelve al horario automático a las",
    voltaHorarioProximo: "Vuelve al horario automático en el próximo evento de horario",
    voltarAutomatico: "Volver al automático",
    informacoesLoja: "Información de la Tienda",
    nomeLoja: "Nombre de la Tienda",
    telefone: "Teléfono",
    email: "Email",
    endereco: "Dirección",
    cidade: "Ciudad",
    estado: "Estado",
    salvarDados: "Guardar Datos",
    salvando: "Guardando...",
    dadosAtualizados: "Datos actualizados!",
    erroSalvar: "Error al guardar",
    idLoja: "ID de Tienda",
    taxasAdmin: "Las tarifas de envío y tiempos son configurados por el administrador en el Panel Admin.",
    integracaoMP: "Integración Mercado Pago",
    configCredenciais: "Configure las credenciales para recibir pagos en línea",
    accessToken: "Access Token",
    publicKey: "Public Key",
    webhookUrl: "Webhook URL",
    credenciaisInfo: "Las credenciales se encuentran en el panel de Mercado Pago en Configuración → Credenciales",
    salvarConfiguracao: "Guardar Configuración",
    apiConfigurada: "API configurada!",
    configImpressora: "Configuración de Impresora",
    tipoConexao: "Tipo de Conexión",
    bluetooth: "Bluetooth",
    usb: "USB",
    wifiRede: "Wi-Fi / Red",
    nomeDispositivo: "Nombre/IP del Dispositivo",
    larguraPapel: "Ancho del Papel",
    imprimirAuto: "Imprimir Automáticamente",
    simImprimir: "Sí - Imprimir al recibir pedido",
    naoImprimir: "No - Imprimir manualmente",
    salvarImpressora: "Guardar Impresora",
    impressoraConfigurada: "Impresora configurada!",
    tiposPagAceitos: "Tipos de Pago Aceptados",
    ativeDesative: "Active o desactive los métodos de pago de su tienda",
    cartaoCredito: "Tarjeta Crédito",
    cartaoDebito: "Tarjeta Débito",
    valeRefeicao: "Vale de Comida",
    pagamentosAtualizados: "Pagos actualizados!",
    salvarPagamentos: "Guardar Pagos",
    horariosAlvo: "Horarios guardados!",

    idiomasTitulo: "Idioma del Panel",
    idiomasDesc: "Elija el idioma de visualización de todo el panel",
    idiomaAtual: "Idioma actual",
    portugues: "Português",
    ingles: "English",
    espanhol: "Español",
    guarani: "Guarani",
    idiomaSalvo: "Idioma cambiado!",
  },

  gn: {
    painelLojista: "Panel Ñemuha",
    menu: "Menú",
    dashboard: "Dashboard",
    pedidos: "Jerure",
    relatorios: "Marandu",
    cadastro: "Ñemoinge",
    configuracao: "Ñemboheko",

    vendidos: "Ñemuhague",
    cancelados: "Oñemboguapyre",
    dia: "Ára",
    mes: "Jasy",
    ano: "Ary",
    financeiro: "Viru",
    pagamentos: "Ñehepyme'ẽ",
    dinheiro: "Viru",
    cartao: "Tarjeta",
    pix: "PIX",
    cashback: "Cashback",
    entregadores: "Mbohasahára",
    geral: "Opavave",
    porEntregador: "Mbohasahára rehe",
    pagos: "Ohepyme'ẽva",
    aReceber: "Og̃uahẽva'erã",
    saldo: "Saldo",

    categorias: "Ñemohenda",
    subCategorias: "Ñemohenda'i",
    produtos: "Mba'e",
    adicionais: "Mbojoapy",
    caixinhaSurpresa: "Kaha Sorpresa",

    horarios: "Ára",
    dadosConta: "Kuenta",
    apiPagamento: "API Ñehepyme'ẽ",
    impressora: "Impresoha",
    tiposPagamento: "Ñehepyme'ẽ lája",
    idiomas: "Ñe'ẽ",

    bemVindo: "Eg̃uahẽ porã",
    faturamento: "Viru ñembyaty",
    totalPedidos: "Jerure opaite",
    ticketMedio: "Ticket mbytegua",
    ativos: "Oñemba'apóva",
    pedidosPorHora: "Jerure aravo rupi",
    ultimosPedidos: "Jerure pahápe",
    verTodos: "Ehechamína opaite →",
    nenhumPedido: "Ndaipóri jerure",
    codigo: "Código",
    status: "Estado",
    pagamento: "Ñehepyme'ẽ",
    total: "Opaite",
    data: "Arange",

    atualizar: "Ñembopyahu",
    todos: "Opaite",
    novos: "Pyahu",
    aceitos: "Oñemoneĩva",
    preparando: "Oñemoĩhína",
    prontos: "Oĩma",
    entrega: "Ñeme'ẽ",
    entregues: "Oñeme'ẽva",
    selecionePedido: "Eiporavo peteĩ jerure",
    informacoes: "Marandu",
    itens: "Mba'e",
    subtotal: "Subtotal",
    taxaEntrega: "Ñeme'ẽ repy",
    desconto: "Desconto",
    recusarPedido: "Emboyke Jerure",
    aceitar: "Emoneĩ",
    ficouPronto: "Oĩma",
    saiuEntrega: "Oho ohasa",
    entregue: "Oñeme'ẽma",

    stNovo: "Pyahu",
    stAceito: "Oñemoneĩva",
    stPreparando: "Oñemoĩhína",
    stPronto: "Oĩma",
    stBuscando: "Ohekahína",
    stEmEntrega: "Ohasahína",
    stEntregue: "Oñeme'ẽma",
    stCancelado: "Oñemboguapyre",

    faturamentoTotal: "Viru opaite",
    formasUtilizadas: "Ñehepyme'ẽ lája",
    semDados: "Ndaipóri",
    novoCadastro: "Ñemoinge Pyahu",
    cadastrados: "Oñemoingyréva",
    nome: "Téra",
    descricao: "Ñe'ẽ",
    sim: "Heẽ",
    nao: "Nahániri",
    ativo: "Oĩva",
    inativo: "Noĩri",
    selecione: "Eiporavo",

    idiomasTitulo: "Panel Ñe'ẽ",
    idiomasDesc: "Eiporavo ñe'ẽ panel opaitegua",
    idiomaAtual: "Ñe'ẽ ag̃agua",
    portugues: "Português",
    ingles: "English",
    espanhol: "Español",
    guarani: "Guarani",
    idiomaSalvo: "Ñe'ẽ oñemoambuema!",
  },
};

export const LANGUAGES = [
  { key: "pt", label: "Português", flag: "🇧🇷" },
  { key: "en", label: "English", flag: "🇺🇸" },
  { key: "es", label: "Español", flag: "🇪🇸" },
  { key: "gn", label: "Guarani", flag: "🇵🇾" },
];

export default function t(lang, key) {
  return translations[lang]?.[key] || translations.pt[key] || key;
}
